import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-home',
  imports: [TranslateModule],
  template: `<h1>{{ 'Home.Welcome' | translate }} {{ user?.name }}</h1>`,
  styles: [
    `
      :host {
        display: block;
      }

      h1 {
        text-align: center;
        margin: 10% 0;
      }
    `
  ],
  standalone: true
})
export class HomeComponent implements OnInit {
  private readonly userService = inject(UserService);

  user!: User;

  ngOnInit(): void {
    const user = this.userService.getMe();
    if (user) {
      this.user = user;
      console.log('User got from session');
    } else {
      console.log('Error when getting user from session');
    }
  }
}
